import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import SettingList from 'components/srv/setting/settingList';
import UnitLoading from 'components/parts/loading/unitLoading';
import Message from 'components/parts/message';

/**
 * 調整プログラム設定一覧画面
*/
const SrvProgramSettings = () => {
  return (
    <div className="col-10 pt-3 pb-3">
      <UnitLoading/>
      <Div>
        <Link to='/srv/setting/regist'>
          <RegistButton>Add</RegistButton>
        </Link>
      </Div>
      <Message/>
      {/* 調整プログラム設定一覧 */}
      <SettingList/>
    </div>
  );
};
const Div = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
`;
const RegistButton = styled(Button)`
  margin-right: 20px;
`;
export default SrvProgramSettings;